document.addEventListener('click',function(e){const a=e.target.closest('a[href^="#"]');if(a){const t=document.querySelector(a.getAttribute('href'));if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'})}}});

/* Product variant price synchronization */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var sectionId = picker.getAttribute('data-section-id');
    var variantsNode = document.getElementById('ProductVariants-' + sectionId);
    var variantIdInput = document.getElementById('ProductVariantId-' + sectionId);
    var priceNode = document.getElementById('ProductPrice-' + sectionId);
    var addButton = document.getElementById('AddToCart-' + sectionId);

    if (!variantsNode || !variantIdInput || !priceNode || !addButton) return;

    var variants;
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (e) {
      return;
    }

    function formatMoney(cents) {
      var amount = cents / 100;
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      }).format(amount);
    }

    function updateVariant() {
      var selected = Array.prototype.map.call(
        picker.querySelectorAll('select[data-option-index]'),
        function (select) { return select.value; }
      );

      var variant = variants.find(function (item) {
        return item.options.length === selected.length &&
          item.options.every(function (value, index) {
            return value === selected[index];
          });
      });

      if (!variant) return;

      variantIdInput.value = variant.id;
      priceNode.textContent = formatMoney(variant.price);

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceNode.textContent = formatMoney(variant.price) + ' (was ' + formatMoney(variant.compare_at_price) + ')';
      }

      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    picker.addEventListener('change', updateVariant);
    updateVariant();
  });
});
